
import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { setContext } from 'apollo-link-context'
import customFetch from '../customFetch';

const getHeaders = () => {
    const headers = {}
    const loginas_token = localStorage.getItem('loginas_jwt_token')
    const token = window.localStorage.getItem('jwt_token')
    console.log(token)
    if (token) {
      console.log(token)
      headers.authorization = `Bearer ${loginas_token?loginas_token:token}`
      headers['access-control-allow-credentials'] = true
    }
    return headers
  }
  const defaultOptions = {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
  }
  const authLink = setContext((_, { headers }) => {
    const token = localStorage.getItem('jwt_token')
    const loginas_token = localStorage.getItem('loginas_jwt_token')
    if (token) {
      return {
        headers: {
          ...headers,
          authorization: token ? `Bearer ${loginas_token?loginas_token:token}` : ''
        }
      }
    } 
  })
  const link = new HttpLink({
    uri:process.env.HASURA_URL,
     fetch:customFetch,
     headers: getHeaders()
   })
   const gqlclient = new ApolloClient({
    link: authLink.concat(link),
    cache: new InMemoryCache({ addTypename: false}),
  defaultOptions: defaultOptions
  })
export default gqlclient


// WEBPACK FOOTER //
// ./src/store/gqlclient.js